/*
 * Person Messages
 *
 * This contains all the text for the Person component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  name: {
    id: 'PERSON_INPUT.name',
    defaultMessage: 'Name',
  },
  type: {
    id: 'PERSON_INPUT.type',
    defaultMessage: 'Type',
    specialist: {
      id: 'PERSON_INPUT.type.specialist',
      defaultMessage: 'Specialist',
    },
    client: {
      id: 'PERSON_INPUT.type.client',
      defaultMessage: 'Client',
    },
  },
  phoneNumber: {
    id: 'PERSON_INPUT.phoneNumber',
    defaultMessage: 'Phone number',
  },
  country: {
    id: 'PERSON_INPUT.country',
    defaultMessage: 'Country',
  },
  timezone: {
    id: 'PERSON_INPUT.timezone',
    defaultMessage: 'Time zone',
  },
  email: {
    id: 'PERSON_INPUT.email',
    defaultMessage: 'Email',
  },
});



// WEBPACK FOOTER //
// ./components/molecules/Person/messages.js